module.exports = __webpack_public_path__ + "static/mobile-mock-web-903d7f4c39979dfa8fc5a2237657d52d.svg";